import React from "react";

import { Grid } from "@material-ui/core";

import { Input } from "components/Form/FormikControls";
import { withNamespace } from "components/Form/FormikControls/lib";
import { Row } from "components/Layout";

interface WhenTabProps {
  saleNamespace: string;
}

export const WhenTab = ({ saleNamespace }: WhenTabProps) => (
  <>
    <Row fullWidth flex alignCenter justifyBetween marginVertical={2}>
      <Grid item xs={12}>
        <Input
          name={withNamespace(saleNamespace, "date")}
          label="Sale Date"
          type="date"
          required
        />
      </Grid>
    </Row>
  </>
);
